import CardanoService from "./../../cardano.js";

async function namiWallet() {
  return await new CardanoService().namiWallet();
}

async function cardanoSerLib() {
  return await import(
    "@emurgo/cardano-serialization-lib-browser/cardano_serialization_lib.js"
  );
}

export async function getAddress() {
  const S = cardanoSerLib();
  return S.Address.from_bytes(Buffer.from(namiWallet(), "hex")).to_bech32();
}

export async function getAssets() {
  const Utxos = await getUtxos();
  const AssetsRaw = [];
  Utxos.forEach((u) => {
    AssetsRaw.push(...u.amount.filter((a) => a.unit !== "lovelace"));
  });
  const AssetsMap = {};

  for (const k of AssetsRaw) {
    const quantity = parseInt(k.quantity);
    if (!AssetsMap[k.unit]) AssetsMap[k.unit] = 0;
    AssetsMap[k.unit] += quantity;
  }
  return Object.keys(AssetsMap).map((k) => ({
    unit: k,
    quantity: AssetsMap[k].toString(),
  }));
}

export async function getAssetsWithLovelace() {
  const Utxos = await getUtxos();
  const AssetsRaw = [];
  Utxos.forEach((u) => {
    AssetsRaw.push(...u.amount);
  });
  const AssetsMap = {};

  for (const k of AssetsRaw) {
    const quantity = parseInt(k.quantity);
    if (!AssetsMap[k.unit]) AssetsMap[k.unit] = 0;
    AssetsMap[k.unit] += quantity;
  }
  return Object.keys(AssetsMap).map((k) => ({
    unit: k,
    quantity: AssetsMap[k].toString(),
  }));
}

export async function getLovelace() {
  const Utxos = await getUtxos();
  const AssetsRaw = [];
  let quantity = 0;
  Utxos.forEach((u) => {
    AssetsRaw.push(...u.amount.filter((a) => a.unit === "lovelace"));
  });
  AssetsRaw.forEach((a) => {
    quantity += parseFloat(a.quantity);
  });

  return quantity;
}

async function getUtxos() {
  const S = await cardanoSerLib();
  const Utxos = (await getUtxosHex()).map((u) =>
    S.TransactionUnspentOutput.from_bytes(Buffer.from(u, "hex"))
  );
  const UTXOS = [];
  for (const utxo of Utxos) {
    const assets = _utxoToAssets(utxo);

    UTXOS.push({
      txHash: Buffer.from(
        utxo.input().transaction_id().to_bytes(),
        "hex"
      ).toString("hex"),
      txId: utxo.input().index(),
      amount: assets,
    });
  }
  return UTXOS;
}

async function getUtxosHex() {
  return await window.cardano.getUtxos();
}

function _utxoToAssets(utxo) {
  const value = utxo.output().amount();
  const assets = [];
  assets.push({ unit: "lovelace", quantity: value.coin().to_str() });
  if (value.multiasset()) {
    const multiAssets = value.multiasset().keys();
    for (let j = 0; j < multiAssets.len(); j++) {
      const policy = multiAssets.get(j);
      const policyAssets = value.multiasset().get(policy);
      const assetNames = policyAssets.keys();
      for (let k = 0; k < assetNames.len(); k++) {
        const policyAsset = assetNames.get(k);
        const quantity = policyAssets.get(policyAsset);
        const asset =
          Buffer.from(policy.to_bytes()).toString("hex") +
          "." +
          Buffer.from(policyAsset.name()).toString("ascii");

        assets.push({
          unit: asset,
          quantity: quantity.to_str(),
        });
      }
    }
  }
  return assets;
}
